import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { MotifLabel, MotifTextArea, MotifButton } from "@ey-xd/motif-react";
import MotifFormField from '@ey-xd/motif-react/FormField';
import "./EditSystemPrompt.scss";

function EditSystemPrompt ({
    systemPrompts,
    setShowEditSystemPrompt,
    handlePromptSave
}) {
    const [saveDisabled, setSaveDisabled] = useState(true);
    const vSysPromptClient = systemPrompts.filter(element => (element.promptCategory === 'client'))[0]?.promptBody;
    const vSysPromptTest = systemPrompts.filter(element => (element.promptCategory === 'testing'))[0]?.promptBody;
    const [clientProjectPrompt, setClientProjectPrompt] = useState(vSysPromptClient);
    const [testingProjectPrompt, setTestingProjectPrompt] = useState(vSysPromptTest);

    useEffect(() => {
        const clientPrompt = systemPrompts.find(element => element.promptCategory === 'client')?.promptBody || "";
        const testPrompt = systemPrompts.find(element => element.promptCategory === 'testing')?.promptBody || "";   
        const isUnchanged = clientProjectPrompt === clientPrompt && testingProjectPrompt === testPrompt;
        setSaveDisabled(isUnchanged);
    }, [clientProjectPrompt, testingProjectPrompt, systemPrompts]);

    const onClientProjectPromptChange = (event) => {
        setClientProjectPrompt(event.target.value);
    }

    const onTestingProjectPromptChange = (event) => {
        setTestingProjectPrompt(event.target.value);
    }

    const onSaveClick = () => {
        const updatedSystemPrompts = systemPrompts.map((sp) => {
            delete sp.promptName;
            delete sp.promptType;

            return {
                ...sp,
                promptBody: sp.promptCategory === "client" ? clientProjectPrompt : testingProjectPrompt,
                promptMethod: "all"
            }
        });

        let updatedPrompt = {
            promptName: "System Prompts",
            promptType: "system",
            prompts: updatedSystemPrompts
        }
        
        handlePromptSave(updatedPrompt);
    }

    return (
        <div className="editSystemPrompt">
            <div className='fldName'>
                <MotifFormField>
                    <MotifLabel className='fldLabel'>
                        Client projects
                    </MotifLabel>
                    <MotifTextArea
                        name="clientProjectPrompt"
                        value={clientProjectPrompt}   
                        onChange={(e) => onClientProjectPromptChange(e)} 
                        rows={5}
                    />
                </MotifFormField>  
            </div>
            <div className='fldName'>
                <MotifFormField>
                    <MotifLabel className='fldLabel'>
                        Testing projects
                    </MotifLabel>
                    <MotifTextArea
                        name="testingProjectPrompt"
                        value={testingProjectPrompt}   
                        onChange={(e) => onTestingProjectPromptChange(e)}  
                        rows={5}
                    />
                </MotifFormField>  
            </div>

            <div className='genericFooter'>
                <div className='footerInner alignEnd'>
                    <MotifButton onClick={() => { setSaveDisabled(true); onSaveClick(); }} className='' type="button" variant="primary" disabled={saveDisabled}>
                        Save
                    </MotifButton>
                    <MotifButton onClick={()=>{setShowEditSystemPrompt(false)}} className='' type="button" variant="secondary">
                        Cancel
                    </MotifButton>
                </div>
            </div>
        </div>
    );
}

EditSystemPrompt.propTypes = {
    systemPrompts: PropTypes.array,
    setShowEditPersonalPrompt: PropTypes.func, 
    handlePromptSave: PropTypes.func 
}

export default EditSystemPrompt;